/**
 * Resolve an artwork media field to a fetchable URL.
 *
 * Index values can be:
 *   - absolute api-storage URL (https://api-storage.../storage/media/{id})
 *   - app-relative path with leading slash ("/cms/...")
 *   - legacy app-relative path without leading slash ("cms/...")
 *   - null / undefined / empty
 */
export function mediaUrl(value: string | null | undefined): string | null {
  if (!value) return null
  if (/^https?:\/\//i.test(value)) return value
  if (value.startsWith('/')) return encodeURI(value)
  return encodeURI('/' + value)
}
